import React, { useEffect, useState } from 'react';
import { Page, Document, Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import OrderProductionDescription from './OrderProductionDescription';
import { testEmpty, convertToNumber, displayCEP, formatMoney, formatPhoneNumber } from '../../../library/helpers/utility';
import SemLogo from '@iso/assets/images/semLogo.png';

let haveLogo = false;
let employeLogoDimensions = [170, 65];
const image = sessionStorage.getItem('employeLogo');

if (image !== null && typeof image !== 'undefined') {
  haveLogo = true;
  employeLogoDimensions = sessionStorage.getItem('employeLogoDimensions').split('x');
}

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    lineHeight: 1.2,
    flexDirection: 'column',
  },
  logo: {
    paddingTop: '10px',
    marginHorizontal: '10%',
    width: employeLogoDimensions[0],
    height: employeLogoDimensions[1]
  },
  reportTitleVertical: {
    color: '#252525',
    letterSpacing: 2,
    fontSize: 12,
    // textAlign: 'center',
    // width: '200px',
    // marginLeft: '-10px',
    marginTop: '25px',
    textTransform: 'uppercase',
    fontFamily: 'Helvetica-Bold',
  },
  reportText: {
    fontFamily: 'Helvetica-Bold',
    marginBottom: 5,
    color: '#000',
    letterSpacing: 1,
    fontSize: 11
  },
});

const OrderProduction = ({ sourceData }) => {

  const EMPTY_CATEGORY = '_____$$__';

  // const [sourceData, setSourceData] = useState(data);
  const [nameSizeBase, setNameSizeBase] = useState(265);
  const [printLayout, setPrintLayout] = useState(sourceData.orderProduction.config.printLayout);
  const [groupingItens, setGroupingItens] = useState([]);
  const [currentSteps, setCurrentSteps] = useState([]);
  const [currentStepsLines, setCurrentStepsLines] = useState([]);

  useEffect(() => {
    aggroupItensByCategory(sourceData);
    makeSteps(sourceData.orderProduction.config.steps);
  }, [sourceData]);

  function makeSteps(steps) {
    try {
      let auxS = [];
      let auxS2 = [];
      let numSteps = steps.length;
      let size = 245 / numSteps;

      for (const key in steps) {
        if (Object.hasOwnProperty.call(steps, key)) {
          const stepName = steps[key];
          auxS.push(
            <Text style={{ width: `${size}px`, borderLeft: '1px #DDD solid', textAlign: 'center', paddingLeft: '2px' }}>{stepName}</Text>
          )
          auxS2.push(
            <Text style={{ width: `${size}px`, borderLeft: '1px #DDD solid', textAlign: 'center', paddingLeft: '2px' }}>&nbsp;</Text>
          )
        }
      }

      setCurrentSteps(auxS);
      setCurrentStepsLines(auxS2);

      if (numSteps === 0)
        setNameSizeBase(510);

    } catch (error) {
      console.log('makeSteps error: ', error)
    }
  }

  function aggroupItensByCategory(data) {
    try {

      let r = {};

      data.orderProduction.itens.forEach(item => {
        item.category = (typeof item.category === 'undefined' || item.category === '') ? EMPTY_CATEGORY : item.category;

        if (typeof r[item.category] === 'undefined')
          r[item.category] = [];

        r[item.category].push(item);
      });

      // console.log(r);
      setGroupingItens(r);

    } catch (error) {
      console.error(error);
    }
  }

  /*

  const listItens = (itens) => {
    let ret = [],
      addData = [],
      nameSize = 265,
      hasTotalizador = false,
      hasAdictionals = false;

    itens.forEach(element => {

      nameSize = 265;
      hasTotalizador = (element.totalizador !== '');
      hasAdictionals = (typeof element.additionalFields !== 'undefined');
      addData = [];

      if (hasTotalizador)
        nameSize -= 40;

      if (hasAdictionals) {
        addData = element.additionalFields.map(add => {
          return `${add.name}: ${add.value}`;
        })

        nameSize -= 100;
      }

      ret.push(
        <View style={{ flexDirection: 'row', border: '1px #DDD solid', marginTop: '-1px' }} key={element.codigo}>
          <Text style={{ width: '35px', borderRight: '1px #DDD solid', textAlign: 'right', paddingRight: '2px' }}>{element.qtd}</Text>
          <Text style={{ width: `${nameSize}px`, paddingLeft: '2px' }}>{element.name} </Text>
          {(hasTotalizador)
            ?
            <Text style={{ width: '40px', paddingLeft: '2px', borderLeft: '1px #DDD solid', textAlign: 'right' }}>{displayNumber(element.totalizador, 3)}</Text>
            : ''
          }
          {(hasAdictionals)
            ?
            <Text style={{ width: '100px', paddingLeft: '2px', borderLeft: '1px #DDD solid', textAlign: 'left' }}>{addData.join(',')}</Text>
            : ''
          }
          <Text style={{ width: '30px', borderLeft: '1px #DDD solid', textAlign: 'center' }}>{element.un_medida}</Text>
        </View>
      )
    });

    return ret;
  }

  const showSteps = (steps) => {
    let ret = [];
    let numSteps = steps.length;
    let size = 245 / numSteps;

    for (const key in steps) {
      if (Object.hasOwnProperty.call(steps, key)) {
        const stepName = steps[key];
        ret.push(
          <Text style={{ width: `${size}px`, borderLeft: '1px #DDD solid', textAlign: 'center', paddingLeft: '2px' }}>{stepName}</Text>
        )
      }
    }

    return ret;
  }

  const listStepsLines = (steps) => {
    let ret = [];
    let numSteps = steps.length;
    let size = 245 / numSteps;

    for (const key in steps) {
      if (Object.hasOwnProperty.call(steps, key)) {
        ret.push(
          <Text style={{ width: `${size}px`, borderLeft: '1px #DDD solid' }}></Text>
        )
      }
    }

    return ret;
  }

  const renderAggupedItens = (itens) => {
    let ret = [],
      hasDisplayedHeader = false;

    for (const key in groupingItens) {
      if (Object.hasOwnProperty.call(groupingItens, key)) {
        const itens = groupingItens[key];

        ret.push(
          <>
            <View style={{ width: '574px', flexDirection: 'row', marginTop: '5px', border: '1px #DDD solid' }}>
                <Text style={{ width: '573px', fontFamily: 'Helvetica-Bold', textAlign:'center'}}>{(key !== EMPTY_CATEGORY) ? key : 'Itens'}</Text>
            </View>
            <View style={{ width: '575px', flexDirection: 'row', marginTop:  (!hasDisplayedHeader) ? '-1px' : '0'}}>
                <View style={{ width: '330px' }}>
                  {
                    (!hasDisplayedHeader) ? 
                      <View style={{ flexDirection: 'row', border: '1px #DDD solid' }}>
                        <Text style={{ width: '35px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Peças</Text>
                        <Text style={{ width: '265px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Material</Text>
                        <Text style={{ width: '29px', fontFamily: 'Helvetica-Bold', textAlign: 'center' }}>Un.</Text>
                      </View>
                    : ''
                  }
                  {listItens(itens)}
                </View>
                <View style={{ width: '245px', marginLeft: '-1px' }}>
                  {
                    (!hasDisplayedHeader) ? 
                      <View style={{ flexDirection: 'row', border: '1px #DDD solid' }}>
                        {showSteps(sourceData.orderProduction.config.steps)}
                      </View>
                    : ''
                  }
                  {
                    itens.map(element => {
                      return <View style={{ flexDirection: 'row', border: '1px #DDD solid', height: '14px', marginTop: '-1px' }}>
                        {listStepsLines(sourceData.orderProduction.config.steps)}
                      </View>
                    })
                  }
                </View>
              </View>
            </>
        )

        hasDisplayedHeader = true;
      }
    }

    return ret;
  }
  
  */

  const renderAggupedItens = (itens) => {
    let ret = [],
      hasDisplayedHeader = false;

    for (const key in groupingItens) {
      if (Object.hasOwnProperty.call(groupingItens, key)) {
        const itens = groupingItens[key];

        ret.push(
          <View style={{ width: '575px', flexDirection: 'column' }}>
            <View style={{ width: '575px', flexDirection: 'row', marginTop: '5px', border: '1px #DDD solid' }}>
              <Text style={{ width: '573px', fontFamily: 'Helvetica-Bold', textAlign: 'center' }}>{(key !== EMPTY_CATEGORY) ? key : 'Itens'}</Text>
            </View>
            <View style={{ width: '575px', flexDirection: 'column', marginTop: (!hasDisplayedHeader) ? '-1px' : '0' }}>
              <View style={{ width: '575px', border: '1px #DDD solid', flexDirection: 'row', marginTop: '-1px' }} key={`header${key}`}>
                {
                  (!hasDisplayedHeader) ?
                    <>
                      <Text style={{ width: '35px', fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Peças</Text>
                      <Text style={{ width: `${nameSizeBase}px`, fontFamily: 'Helvetica-Bold', borderRight: '1px #DDD solid' }}>Material</Text>
                      <Text style={{ width: '29px', fontFamily: 'Helvetica-Bold', textAlign: 'center' }}>Un.</Text>
                      {currentSteps}
                    </>
                    : ''
                }
              </View>

              {listItens(itens)}

              {/* {
                     itens.map(element => {
                       return <View style={{ flexDirection: 'row', border: '1px #DDD solid', height: '14px', marginTop: '-1px' }}>
                         {listStepsLines(sourceData.orderProduction.config.steps)}
                       </View>
                     })
                   } */}

            </View>
          </View>
        )

        hasDisplayedHeader = true;
      }
    }

    return ret;
  }


  const listItens = (itens) => {
    let ret = [],
      addData = [],
      nameSize = nameSizeBase,
      hasTotalizador = false,
      hasAdictionals = false;

    itens.forEach(element => {

      nameSize = nameSizeBase;
      hasTotalizador = (element.totalizador !== '');
      hasAdictionals = (typeof element.additionalFields !== 'undefined');
      addData = [];

      if (hasTotalizador)
        nameSize -= 40;

      if (hasAdictionals) {
        addData = element.additionalFields.map(add => {
          return `${add.name}: ${add.value}`;
        })

        nameSize -= 100;
      }

      ret.push(
        <View style={{ width: '575px', flexDirection: 'row', border: '1px #DDD solid', marginTop: '-1px' }} key={element.codigo}>
          <Text style={{ width: '35px', borderRight: '1px #DDD solid', textAlign: 'right', paddingRight: '2px' }}>{element.qtd}</Text>
          <Text style={{ width: `${nameSize}px`, paddingLeft: '2px' }}>{element.name} </Text>
          {(hasTotalizador)
            ?
            <Text style={{ width: '40px', paddingLeft: '2px', borderLeft: '1px #DDD solid', textAlign: 'right' }}>{displayNumber(element.totalizador, 3)}</Text>
            : ''
          }
          {(hasAdictionals)
            ?
            <Text style={{ width: '100px', paddingLeft: '2px', borderLeft: '1px #DDD solid', textAlign: 'left' }}>{addData.join(',')}</Text>
            : ''
          }
          <Text style={{ width: '30px', borderLeft: '1px #DDD solid', textAlign: 'center' }}>{element.un_medida}</Text>
          {currentStepsLines}
        </View>
      )
    });

    return ret;
  }

  const displayNumber = (n, d) => {
    return formatMoney(n + '', { significantDigits: d, decimalSeparator: '.' })
  }

  const renderParameters = (source) => {
    let r = '';

    try {

      let parameters = source?.orderProduction?.parameters;

      // console.log('source: ', source);
      // console.log('source?.orderProduction: ', source?.orderProduction);
      // console.log('parameters: ', parameters);

      if (typeof parameters !== 'undefined') {
        if (typeof parameters.largura !== 'undefined') {
          r += `Largura: ${displayNumber(convertToNumber(parameters.largura + ''), 3)}, `;
        }
        if (typeof parameters.altura !== 'undefined') {
          r += `Altura: ${displayNumber(convertToNumber(parameters.altura + ''), 3)}, `;
        }
        if (typeof parameters.quantidade !== 'undefined' && r === '') {
          r += `Quantidade: ${displayNumber(convertToNumber(parameters.quantidade + ''), 3)}, `;
        }

        r = r.slice(0, r.length - 2);
      }
    } catch (error) {
      console.log('Erro render: ', error);
    }
    return r;
  }

  const renderGrid = (grid) => {
    let r = '';
    try {
      if (typeof grid !== 'undefined' && grid !== null) {
        for (const key in grid) {
          if (Object.hasOwnProperty.call(grid, key)) {
            const val = grid[key];
            r += `${key}: ${val}, `;
          }
        }
        r = r.slice(0, r.length - 2);
      }
    } catch (error) {
      console.log('Erro render 2: ', error);
    }
    return r;
  }

  const renderAddress = (address) => {
    let ret = '';

    if (typeof address !== 'undefined') {
      if (typeof address.address !== 'undefined')
        ret += `${address.address}, `;
      if (typeof address.numberHouse !== 'undefined')
        ret += `${address.numberHouse}, `;
      if (typeof address.neighborhood !== 'undefined')
        ret += `${address.neighborhood}, `;
      if (typeof address.complement !== 'undefined')
        ret += `${address.complement}, `;
      if (typeof address.city !== 'undefined')
        ret += `${sourceData.orderProduction.client.address.city}/${sourceData.orderProduction.client.address.state}, `
      if (typeof address.cep !== 'undefined')
        ret += `CEP: ${displayCEP(address.cep)}, `;

      ret = ret.slice(0, ret.length - 2);
    }

    return ret;
  }

  const getDateFields = () => {
    return <>____/____/_______</>
  }

  return (
    <Document>
      <Page size="A4" orientation={(printLayout === 'horizontal') ? 'landscape' : 'portrait'} style={styles.page}>
        {
          (printLayout === 'horizontal') ?
            <>
              <Text>Layout não disponível no momento!</Text>
            </>
            :
            <>
              <View style={{ width: '575px', height: '60px', flexDirection: 'row' }}>
                <View style={{ width: '150px', flexDirection: 'column', padding: ' 0 2px 0 2px' }}>
                  <Image style={styles.logo} src={(haveLogo) ? image : SemLogo} />
                </View>
                <View style={{ width: '310px', flexDirection: 'column', textAlign: 'center', padding: ' 0 2px 0 2px' }}>
                  <Text style={styles.reportTitleVertical}>{sourceData.title}</Text>
                </View>
                <View style={{ width: '140px', flexDirection: 'column', padding: ' 0 2px 0 2px' }}>
                  <View style={{ width: '150px', flexDirection: 'row', marginTop: '15px' }}>
                    <Text style={{ width: '37px', fontFamily: 'Helvetica-Bold', marginLeft: '2px', textAlign: 'right' }}>Início:</Text>
                    <Text style={{ width: '95px' }}>{getDateFields()}</Text>
                  </View>
                  <View style={{ width: '150px', flexDirection: 'row', marginTop: '10px' }}>
                    <Text style={{ width: '37px', fontFamily: 'Helvetica-Bold', marginLeft: '2px', textAlign: 'right' }}>Fim:</Text>
                    <Text style={{ width: '95px' }}>{getDateFields()}</Text>
                  </View>
                </View>
              </View>

              {/* Cliente */}

              <View style={{ width: '575px', flexDirection: 'column', marginTop: '15px' }}>
                <View style={{ width: '575px', flexDirection: 'row', border: '1px #DDD solid', padding: ' 0 2px 0 2px' }}>
                  <Text style={{ width: '40px', fontFamily: 'Helvetica-Bold' }}>Cliente:</Text>
                  <Text style={{ width: '384px', borderRight: '1px #DDD solid' }}>{`${sourceData.orderProduction.client.name}`}</Text>
                  <Text style={{ width: '60px', fontFamily: 'Helvetica-Bold', marginLeft: '2px', textAlign: 'right', paddingRight: '2px' }}>Telefone:</Text>
                  <Text style={{ width: '92px', marginLeft: '2px' }}>{`${formatPhoneNumber(sourceData.orderProduction.client.fone)}`}</Text>
                </View>
                <View style={{ width: '575px', flexDirection: 'row', border: '1px #DDD solid', padding: ' 0 2px 0 2px', marginTop: '-1px' }}>
                  <Text style={{ width: '52px', fontFamily: 'Helvetica-Bold' }}>Endereço:</Text>
                  <Text style={{ width: '500px' }}>
                    {renderAddress(sourceData.orderProduction.client.address)}
                  </Text>
                </View>
              </View>

              {/* Produto */}

              <View style={{ width: '575px', flexDirection: 'column', marginTop: '5px' }}>
                <View style={{ width: '575px', flexDirection: 'row', border: '1px #DDD solid', padding: ' 0 2px 0 2px' }}>
                  <Text style={{ width: '45px', fontFamily: 'Helvetica-Bold' }}>Produto:</Text>
                  <Text style={{ width: '530px' }}>{sourceData.orderProduction.product.name}</Text>
                </View>
                <View style={{ width: '575px', flexDirection: 'row', border: '1px #DDD solid', padding: ' 0 2px 0 2px', marginTop: '-1px' }}>
                  <Text style={{ width: '62px', fontFamily: 'Helvetica-Bold' }}>Parâmetros:</Text>
                  <Text style={{ width: '138px' }}>{renderParameters(sourceData)}</Text>
                  {
                    (testEmpty(sourceData.orderProduction.grid, '') !== '' && Object.keys(sourceData.orderProduction.grid).length > 0) ?
                      <>
                        <Text style={{ width: '37px', fontFamily: 'Helvetica-Bold', marginLeft: '2px', paddingLeft: '5px', borderLeft: '1px #DDD solid' }}>Grade:</Text>
                        <Text style={{ width: '274px' }}>{renderGrid(sourceData.orderProduction.grid)}</Text>
                      </>
                      : ''
                  }
                </View>
              </View>

              {/* Itens e etapas */}

              {renderAggupedItens(groupingItens)}

              {/* INFORMAÇÕES adicionais */}

              <OrderProductionDescription data={sourceData} />

              {/* Data final e assinatura */}

              <View key={"container"} style={{ flexDirection: 'row', marginTop: '10px' }}>
                <View key={"collumDate"} style={{ width: '235px', flexDirection: 'row' }}>
                  <Text style={{ width: '100px' }}>Data de aprovação: </Text>
                  <Text style={{ width: '100px' }}>{getDateFields()}</Text>
                </View>
                <View key={"collum"} style={{ width: '250px', flexDirection: 'row' }}>
                  <Text key={"company"} style={{ width: '130px', textAlign: 'center' }}>
                    Assinatura do responsável:
                  </Text>
                  <Text style={{ width: '120px' }}>______________________________________</Text>
                </View>
              </View>

            </>
        }
      </Page>
    </Document>
  )
};

export default OrderProduction